
import React from 'react';

interface CsvRowSelectorProps {
  data: any[];
  selectedRows: Set<number>;
  onToggleRow: (index: number) => void;
  onSelectAll: (all: boolean) => void;
}

export const CsvRowSelector: React.FC<CsvRowSelectorProps> = ({ 
  data, 
  selectedRows = new Set(), 
  onToggleRow, 
  onSelectAll 
}) => {
  if (data.length === 0) return null;

  const headers = Object.keys(data[0]);
  const isAllSelected = selectedRows.size === data.length && data.length > 0;

  return (
    <div className="space-y-2">
      <div className="flex justify-between items-center">
        <label className="text-xs font-black text-gray-400 uppercase tracking-widest">
          4. Seleccionar Filas ({selectedRows.size} de {data.length})
        </label>
        <button 
          onClick={() => onSelectAll(!isAllSelected)}
          className="text-[10px] font-bold text-sky-600 hover:underline uppercase"
        >
          {isAllSelected ? 'Desmarcar todos' : 'Marcar todos'}
        </button>
      </div>
      
      <div className="border border-gray-200 rounded-xl overflow-hidden bg-white max-h-60 overflow-y-auto">
        <table className="w-full text-left border-collapse">
          <thead className="bg-gray-50 sticky top-0 z-10">
            <tr>
              <th className="p-2 border-b w-10">
                <input 
                  type="checkbox" 
                  checked={isAllSelected}
                  onChange={(e) => onSelectAll(e.target.checked)}
                  className="rounded text-sky-600"
                />
              </th>
              {headers.slice(0, 4).map(h => (
                <th key={h} className="p-2 border-b text-[10px] font-black text-gray-500 uppercase truncate max-w-[100px]">
                  {h}
                </th>
              ))}
              {headers.length > 4 && <th className="p-2 border-b text-[10px] font-black text-gray-500 uppercase">...</th>}
            </tr>
          </thead>
          <tbody className="divide-y divide-gray-100">
            {data.map((row, idx) => (
              <tr key={idx} className={`hover:bg-sky-50/30 transition-colors ${selectedRows.has(idx) ? 'bg-sky-50/20' : ''}`}>
                <td className="p-2">
                  <input 
                    type="checkbox" 
                    checked={selectedRows.has(idx)}
                    onChange={() => onToggleRow(idx)}
                    className="rounded text-sky-600"
                  />
                </td>
                {headers.slice(0, 4).map(h => (
                  <td key={h} className="p-2 text-xs text-gray-600 truncate max-w-[100px]">
                    {String(row[h] || '')}
                  </td>
                ))}
                {headers.length > 4 && <td className="p-2 text-xs text-gray-400 italic">+{headers.length - 4}</td>}
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </div>
  );
};
